module.exports = __webpack_public_path__ + "static/media/LoadingSceenWithDots.1deb6bb6.gif";